(function () {

  /*
   * ==========================================
   * SETTINGS
   * ==========================================
   */

  const FREE_GIFT_THRESHOLD = 7000;     // $70
  const FREE_SHIPPING_THRESHOLD = 9000; // $90

  /*
   * IMPORTANT:
   * Replace this with the actual gift VARIANT ID.
   */
  const FREE_GIFT_VARIANT_ID = 0;


  let refreshTimer = null;
  let progressUpdating = false;
  let giftUpdating = false;


  /*
   * ==========================================
   * GET CART
   * ==========================================
   */

  async function getCart() {

    const response = await fetch(
      window.Shopify.routes.root + 'cart.js',
      {
        method: 'GET',
        credentials: 'same-origin',
        cache: 'no-store'
      }
    );

    if (!response.ok) {
      throw new Error('Unable to load cart');
    }

    return await response.json();
  }


  /*
   * ==========================================
   * IDENTIFY FREE GIFT
   * ==========================================
   */

  function isGiftItem(item) {

    if (!item) {
      return false;
    }

    const sameVariant =
      Number(item.variant_id) ===
      Number(FREE_GIFT_VARIANT_ID);

    const giftProperty =
      item.properties &&
      (
        item.properties._free_gift === 'true' ||
        item.properties._free_gift === true
      );

    return sameVariant || giftProperty;
  }


  /*
   * ==========================================
   * GET QUALIFYING QUANTITY
   *
   * Gift does NOT count toward:
   * 3 = 15%
   * 4 = 20%
   * 5 = 25%
   * ==========================================
   */

  function getCartQuantity(cart) {

    return cart.items.reduce(function (total, item) {

      if (isGiftItem(item)) {
        return total;
      }

      return total + Number(item.quantity || 0);

    }, 0);
  }


  /*
   * ==========================================
   * FIND GIFT LINE
   * ==========================================
   */

  function getGiftItem(cart) {

    return cart.items.find(function (item) {
      return isGiftItem(item);
    });

  }


  /*
   * ==========================================
   * ADD FREE GIFT
   * ==========================================
   */

  async function addFreeGift() {

    if (giftUpdating) {
      return;
    }

    giftUpdating = true;

    try {

      const response = await fetch(
        window.Shopify.routes.root + 'cart/add.js',
        {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },

          body: JSON.stringify({
            items: [
              {
                id: FREE_GIFT_VARIANT_ID,
                quantity: 1,

                /*
                 * Private line property.
                 * Helps keep gift line separate.
                 */
                properties: {
                  '_free_gift': 'true'
                }
              }
            ]
          })
        }
      );

      if (!response.ok) {

        const errorData =
          await response.json().catch(function () {
            return {};
          });

        throw new Error(
          errorData.description ||
          'Unable to add free gift'
        );
      }


      /*
       * Tell the theme/cart drawer something changed.
       */
      document.dispatchEvent(
        new CustomEvent('cart:refresh')
      );

      document.dispatchEvent(
        new CustomEvent('cart:updated')
      );


    } catch (error) {

      console.error(
        'Free gift add error:',
        error
      );

    } finally {

      giftUpdating = false;

    }
  }


  /*
   * ==========================================
   * REMOVE FREE GIFT
   * ==========================================
   */

  async function removeFreeGift(giftItem) {

    if (
      !giftItem ||
      giftUpdating
    ) {
      return;
    }

    giftUpdating = true;

    try {

      const response = await fetch(
        window.Shopify.routes.root + 'cart/change.js',
        {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },

          body: JSON.stringify({
            id: giftItem.key,
            quantity: 0
          })
        }
      );

      if (!response.ok) {
        throw new Error(
          'Unable to remove free gift'
        );
      }


      document.dispatchEvent(
        new CustomEvent('cart:refresh')
      );

      document.dispatchEvent(
        new CustomEvent('cart:updated')
      );


    } catch (error) {

      console.error(
        'Free gift remove error:',
        error
      );

    } finally {

      giftUpdating = false;

    }
  }


  /*
   * ==========================================
   * FREE GIFT LOGIC
   * ==========================================
   */

  async function handleFreeGift(cart) {

    const giftItem =
      getGiftItem(cart);

    /*
     * Shopify total_price is in cents.
     *
     * Gift is free after Shopify discount,
     * therefore it should not increase total_price.
     */

    const cartTotal =
      Number(cart.total_price || 0);


    /*
     * $70+ and gift missing
     */
    if (
      cartTotal >= FREE_GIFT_THRESHOLD &&
      !giftItem
    ) {

      await addFreeGift();

      return true;
    }


    /*
     * Below $70 and gift exists
     */
    if (
      cartTotal < FREE_GIFT_THRESHOLD &&
      giftItem
    ) {

      await removeFreeGift(giftItem);

      return true;
    }


    return false;
  }


  /*
   * ==========================================
   * ONE STEP AT A TIME PROGRESS BAR
   *
   * ORDER:
   *
   * $70 = Free Gift
   * $90 = Free Shipping
   * 3 = 15%
   * 4 = 20%
   * 5 = 25%
   * ==========================================
   */

  function updateSingleOfferProgress(cart) {

  const message =
    document.querySelector('#cart-offer-message');

  const fill =
    document.querySelector('#single-offer-fill');

  const leftTitle =
    document.querySelector('#offer-left-title');

  const leftValue =
    document.querySelector('#offer-left-value');

  const rightTitle =
    document.querySelector('#offer-right-title');

  const rightValue =
    document.querySelector('#offer-right-value');


  if (
    !message ||
    !fill ||
    !leftTitle ||
    !leftValue ||
    !rightTitle ||
    !rightValue
  ) {
    return;
  }


  const quantity =
    getCartQuantity(cart);

  const total =
    Number(cart.total_price || 0);


  let percentage = 0;


  /*
   * ==================================================
   * STEP 1
   * Below $70
   * Next reward = FREE GIFT
   * ==================================================
   */

  if (total < FREE_GIFT_THRESHOLD) {

    const remaining =
      FREE_GIFT_THRESHOLD - total;


    message.textContent =
      'Spend $' +
      (remaining / 100).toFixed(2) +
      ' more for your 🎁 FREE gift';


    percentage =
      (total / FREE_GIFT_THRESHOLD) * 100;


    leftTitle.textContent =
      'Start';

    leftValue.textContent =
      '';


    rightTitle.textContent =
      'Free Gift';

    rightValue.textContent =
      '$70';

  }


  /*
   * ==================================================
   * STEP 2
   * $70 reached
   * Next reward = FREE SHIPPING at $90
   * ==================================================
   */

  else if (total < FREE_SHIPPING_THRESHOLD) {

    const remaining =
      FREE_SHIPPING_THRESHOLD - total;


    message.innerHTML =
  '🎁 FREE Gift unlocked!<br>Spend $' +
  (remaining / 100).toFixed(2) +
  ' more for 🚚 FREE Shipping!';


    /*
     * Progress only between $70 → $90
     */
    percentage =
      (
        (total - FREE_GIFT_THRESHOLD) /
        (
          FREE_SHIPPING_THRESHOLD -
          FREE_GIFT_THRESHOLD
        )
      ) * 100;


    leftTitle.textContent =
      'Free Gift';

    leftValue.textContent =
      '$70';


    rightTitle.textContent =
      'Free shipping';

    rightValue.textContent =
      '$90';

  }


  /*
   * ==================================================
   * STEP 3
   * Gift + Shipping unlocked
   * Next = 3 items / 15%
   * ==================================================
   */

  else if (quantity < 3) {

    const remaining =
      3 - quantity;


    message.innerHTML =
  '🎁 FREE Gift + 🚚 Shipping unlocked!<br>Add ' +
  remaining +
  ' more ' +
  (
    remaining === 1
      ? 'item'
      : 'items'
  ) +
  ' for 15% OFF!';

    percentage =
      (quantity / 3) * 100;


    leftTitle.textContent =
      'Free shipping';

    leftValue.textContent =
      '$90';


    rightTitle.textContent =
      '15% OFF';

    rightValue.textContent =
      '3 Items';

  }


  /*
   * ==================================================
   * STEP 4
   * 3 items = 15%
   * Next = 4 items / 20%
   * ==================================================
   */

  else if (quantity === 3) {

   
    message.innerHTML =
    '🎁 FREE Gift + 🚚 Shipping!  15% OFF unlocked!<br>Add 1 item for 20% OFF!';

    /*
     * Current stage:
     * 3 → 4 items
     */
    percentage = 50;


    leftTitle.textContent =
      '15% OFF';

    leftValue.textContent =
      '3 Items';


    rightTitle.textContent =
      '20% OFF';

    rightValue.textContent =
      '4 Items';

  }


  /*
   * ==================================================
   * STEP 5
   * 4 items = 20%
   * Next = 5 items / 25%
   * ==================================================
   */

  else if (quantity === 4) {

    message.innerHTML =
    '🎁 FREE Gift + 🚚 Shipping + 20% OFF unlocked!<br>Add 1 item for 25% OFF!';


    percentage = 50;


    leftTitle.textContent =
      '20% OFF';

    leftValue.textContent =
      '4 Items';


    rightTitle.textContent =
      '25% OFF';

    rightValue.textContent =
      '5 Items';

  }


  /*
   * ==================================================
   * EVERYTHING UNLOCKED
   * ==================================================
   */

  else {

    message.innerHTML =
  '🎁 FREE Gift + 🚚 Shipping + 25% OFF unlocked!';


    percentage = 100;


    leftTitle.textContent =
      '25% OFF';

    leftValue.textContent =
      '5 Items';


    rightTitle.textContent =
      'All Unlocked';

    rightValue.textContent =
      '';

  }


  /*
   * Keep progress between 0% and 100%
   */
  percentage =
    Math.max(
      0,
      Math.min(
        percentage,
        100
      )
    );


  fill.style.width =
    percentage + '%';
}



/*
 * ==========================================
 * MAIN REFRESH
 * ==========================================
 */

async function refreshCartProgress() {

  if (progressUpdating) {
    return;
  }


  progressUpdating = true;


  try {

    const cart =
      await getCart();


    console.log(
      'Cart offer:',
      {
        quantity:
          getCartQuantity(cart),

        total:
          cart.total_price
      }
    );


    updateSingleOfferProgress(
      cart
    );


  } catch (error) {

    console.error(
      'Cart progress error:',
      error
    );

  } finally {

    progressUpdating = false;

  }
}

  /*
   * ==========================================
   * DEBOUNCE
   * ==========================================
   */

  function scheduleRefresh(delay) {

    clearTimeout(
      refreshTimer
    );

    refreshTimer =
      setTimeout(
        refreshCartProgress,
        delay || 300
      );
  }


  /*
   * ==========================================
   * INITIAL LOAD
   * ==========================================
   */

  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      function () {
        scheduleRefresh(300);
      }
    );

  } else {

    scheduleRefresh(300);

  }


  /*
   * ==========================================
   * QUANTITY BUTTONS
   * ==========================================
   */

  document.addEventListener(
    'click',
    function (event) {

      const quantityButton =
        event.target.closest(
          [
            '.quantity__button',
            'quantity-input button',
            '[name="plus"]',
            '[name="minus"]'
          ].join(',')
        );


      if (!quantityButton) {
        return;
      }


      /*
       * Wait for Shopify AJAX update.
       */
      setTimeout(
        refreshCartProgress,
        350
      );

      setTimeout(
        refreshCartProgress,
        700
      );

      setTimeout(
        refreshCartProgress,
        1200
      );

    }
  );


  /*
   * ==========================================
   * MANUAL QUANTITY CHANGE
   * ==========================================
   */

  document.addEventListener(
    'change',
    function (event) {

      if (
        event.target.matches(
          [
            '.quantity__input',
            'quantity-input input',
            'input[name="updates[]"]'
          ].join(',')
        )
      ) {

        setTimeout(
          refreshCartProgress,
          400
        );

        setTimeout(
          refreshCartProgress,
          900
        );

      }

    }
  );


  /*
   * ==========================================
   * COMMON SHOPIFY CART EVENTS
   * ==========================================
   */

  [
    'cart:updated',
    'cart:refresh',
    'cart:update',
    'cartUpdate',
    'cart-updated',
    'cart-drawer:updated'
  ].forEach(function (eventName) {

    document.addEventListener(
      eventName,
      function () {
        scheduleRefresh(250);
      }
    );

  });


  /*
   * ==========================================
   * WATCH CART DRAWER DOM
   * ==========================================
   */

  const observer =
    new MutationObserver(
      function () {

        scheduleRefresh(350);

      }
    );


  observer.observe(
    document.body,
    {
      childList: true,
      subtree: true
    }
  );


  /*
   * ==========================================
   * WATCH SHOPIFY AJAX CART REQUESTS
   * ==========================================
   */

  const originalFetch =
    window.fetch;


  window.fetch =
    async function () {

      const args =
        arguments;

      const request =
        args[0];

      const url =
        typeof request === 'string'
          ? request
          : (
              request &&
              request.url
                ? request.url
                : ''
            );


      const response =
        await originalFetch.apply(
          this,
          args
        );


      /*
       * Do not trigger repeated refreshes
       * while our gift function is changing cart.
       */
      if (
        !giftUpdating &&
        (
          url.includes('/cart/add') ||
          url.includes('/cart/change') ||
          url.includes('/cart/update') ||
          url.includes('/cart/clear')
        )
      ) {

        setTimeout(
          refreshCartProgress,
          300
        );

        setTimeout(
          refreshCartProgress,
          700
        );

        setTimeout(
          refreshCartProgress,
          1100
        );

      }


      return response;

    };


  /*
   * ==========================================
   * DEBUG / MANUAL REFRESH
   * ==========================================
   */

  window.refreshCartProgress =
    refreshCartProgress;

})();

/*
 * ==========================================
 * CATCH XHR CART UPDATES
 * Some Shopify themes use XMLHttpRequest
 * instead of fetch().
 * ==========================================
 */

(function () {

  const originalOpen =
    XMLHttpRequest.prototype.open;

  const originalSend =
    XMLHttpRequest.prototype.send;


  XMLHttpRequest.prototype.open =
    function (method, url) {

      this._cartOfferUrl =
        typeof url === 'string'
          ? url
          : '';

      return originalOpen.apply(
        this,
        arguments
      );

    };


  XMLHttpRequest.prototype.send =
    function () {

      const xhr = this;

      const url =
        xhr._cartOfferUrl || '';


      if (
        url.includes('/cart/add') ||
        url.includes('/cart/change') ||
        url.includes('/cart/update') ||
        url.includes('/cart/clear')
      ) {

        xhr.addEventListener(
          'load',
          function () {

            setTimeout(
              refreshCartProgress,
              200
            );

            setTimeout(
              refreshCartProgress,
              500
            );

            setTimeout(
              refreshCartProgress,
              900
            );

          }
        );

      }


      return originalSend.apply(
        this,
        arguments
      );

    };

})();